import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Button, Icon, Input, Layout,Select } from 'antd';
import appActions from '../../redux/app/actions';
import TopbarUser from './topbarUser';
import TopbarWrapper from './topbar.style';
import themes from '../../config/themes';
import { themeConfig } from '../../config';
import {hasAccessOf} from "../../helpers/permission";
import { getClientsList, isOwner, isProfessionalFunc } from '../../helpers/helper';

const { Header } = Layout;
const { Option } = Select;
const { toggleCollapsed } = appActions;
const customizedTheme = themes[themeConfig.theme];

class Topbar extends Component {
  constructor(props){
    super(props);
    this.state={
      clientId:'',
      clients:[],
    }
  }

  async componentDidMount() {
    const clients = await getClientsList();
    this.setState({
      clients
    })
  }

  handleChangeClient=(e)=>{
    this.setState({
      clientId : e
    },()=>{
      localStorage.setItem('selectedUser',e);
      this.props.history.push('/app/clients');
    })
  };
  render() {
    const { toggleCollapsed,url } = this.props;
    const { clients } = this.state;
    const collapsed = this.props.collapsed && !this.props.openDrawer;
    const enterprisePlan = localStorage.getItem('enterprisePlan') === "true";
    let UserRoles = localStorage.getItem('currentPlan');
    UserRoles = UserRoles ? JSON.parse(UserRoles) : [];
    return (
      <TopbarWrapper>
        <Header
          className={
            collapsed
              ? 'isomorphicTopbar collapsed bt_portal-top_bar'
              : 'isomorphicTopbar bt_portal-top_bar'
          }
        >
          {/* TODO: remove this when making fixed sidebar */}
          <div className='isoLeft' id='topbar-container'
          >
            {/*  <button */}
            {/*    className={ */}
            {/*      collapsed ? 'triggerBtn menuCollapsed' : 'triggerBtn menuOpen' */}
            {/*    } */}
            {/*    style={{ color: customizedTheme.textColor }} */}
            {/*    onClick={toggleCollapsed} */}
            {/*  /> */}
            <Select
                showSearch
                style={{ width: 200 }}
                placeholder={(<span className='-flex-space-between'>Search Client <Icon type='search'/></span>)}
                optionFilterProp="children"
                className='bt_portal-select'
                showArrow={false}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={this.handleChangeClient}
            >
              {clients && clients.length ?clients.map(({id,personalDetail})=>
                      <Option value={id}>{personalDetail.first+' '+personalDetail.last}</Option>)
                  :''}
            </Select>
            <Button className='bt-portal-button margin-left-one' onClick={()=>{
              localStorage.setItem('selectedUser','');
              this.props.history.push({
                pathname: '/app/clients',
                state: { isAdd: true,activeKey:'overview'}
              });
            }}>
              <Icon type='plus-circle' theme='filled' /> Add
            </Button>
          </div>

          <ul className='isoRight'>
            {!isProfessionalFunc()  ?
              !enterprisePlan && hasAccessOf('UpgradePlan') ? <Button hidden={!(isOwner())} className='bt-portal-button margin-right-one'
                                                    onClick={() => this.props.history.push(`${url}/upgrade-plan`)}>
                  {UserRoles.planRef=== '1' ? 'Upgrade My Account' : 'Switch Plan'}
              </Button> : ''
               : null}
            <li onClick={() => this.setState({ selectedItem: 'user' })} className='isoUser'>
              <TopbarUser {...this.props} />
            </li>
          </ul>
        </Header>
      </TopbarWrapper>
    );
  }
}

export default withRouter(connect(
  state => ({
    ...state.App.toJS(),
  }),
  { toggleCollapsed },
)(Topbar));
